import { Room as SocketRoom } from '@knitiv/api-client-javascript';
import ChatConstants from '~/pages/chat/chat.constant';

export default class Room {
	/**
	 * Create a Room
	 *
	 * @param room
	 * @param {string} currentPerson
	 */
	constructor(room, currentPerson) {
		this.data = room.data;
		this.datecreation = room.datecreation;
		this.id = room.id;
		this.ref = room.ref;
		this.type = room.type;
		this.status = 'offline';
		this.repre = this.ref;
		this.isLoading = false;
		this.isLocked = false;

		this.upFetchDate = null;
		this.noMoreMessagesUp = false;

		this.downFetchDate = null;
		this.noMoreMessagesDown = null;

		this.lastMessageText = undefined;
		this.initialFetchDone = false;
		this.isRecent = false;
		this.isSelected = false;
		this.lastAccess = undefined;
		this.sender = undefined;
		this.receiver = undefined;
		this.unreadMessages = 0;
		this.autoScrollDown = true;
		this.scrollTop = 0;

		this.currentPerson = currentPerson;
		this.listener = null;
	}

	/**
	 *
	 * @param {SocketRoom} listener
	 */
	setListener(listener) {
		this.listener = listener;
	}

	isOneToOne() {
		return this.type === 'user';
	}

	isGroup() {
		return this.type === 'group';
	}

	getRoomParts() {
		try {
			// console.log('this.node.kid', this.id);
			const result = new RegExp(`^(K_NODE;.*?)${ChatConstants.joinDMChar}(K_NODE;.*?)$`).exec(this.id);
			// console.log('result', result);
			const [, left, right] = result;
			return [left, right];
		}
		catch (error) {
			console.error('Impossible de récupérer les parties', error);
			return [];
		}
	}

	getPath() {
		return `/chat/${this.ref}`;
	}

	async init() {
		// Fetch Repre
		if (this.isGroup()) {
			this.sender = this.currentPerson;
			this.receiver = this.id;
		}
		if (this.isOneToOne()) {
			const parts = this.getRoomParts();
			for (const part of parts) {
				if (part === this.currentPerson) {
					this.sender = part;
				}
				else {
					this.receiver = part;
				}
			}
		}
		this.isLoading = false;
		return this;
		// try {
		// const repre = await this.API.objectRepreGet([this.receiver], 'simple');
		// this.repre = repre.result[this.receiver];
		// }
		// catch (error) {
		// 	console.error(error);
		// 	return undefined;
		// }
		// ---
	}
}
